module.exports = __webpack_public_path__ + "img/exclamation.3f9c658a.svg";